import React, {Fragment} from "react";

// components
import FirstLevel from "./Table/FirstLevel";
import {CompositeFilterDescriptor} from "@progress/kendo-data-query";

interface Props {
  tableData: any[];
  fetchingSellerStats: boolean;
  exportButton: () => JSX.Element;
  sendFilters: () => void;
  take: number;
  skip: number;
  total: number;
  activeFilters: CompositeFilterDescriptor
  featuresAllowed: string[];
}

export default (props: Props) => {

  return (
    <Fragment>
      <FirstLevel
        tableData={props.tableData}
        fetchingSellerStats={props.fetchingSellerStats}
        sendFilters={props.sendFilters}
        take={props.take}
        skip={props.skip}
        total={props.total}
        activeFilters={props.activeFilters}
        featuresAllowed={props.featuresAllowed}
      />
    </Fragment>
  );
};
